import React, { Fragment, Helmet, useState, useEffect } from "react";
import {
  GetSiteData,
  checkEmpty,
  FormSubmitSite,
  ShowData,
} from "../Components/Services";
import CommonFrom from "../../../../Common/Components/Form";
import Loading from "../../../../Common/Components/Loading";

function Index() {
  const initialState = {
    data: null,
    loading: true,
  };

  const [state, setstate] = useState(initialState);

  const handler = () => {
    setstate({ ...state, loading: true });
    GetSiteData().then(data => {
      setstate({ ...state, loading: false, data: data });
    });
  };

  const submit = data => {
    setstate({ ...state, loading: true });
    FormSubmitSite(data).then(() => {
      setstate({ ...state, loading: false });

      handler();
    });
  };

  useEffect(() => {
    handler();
  }, []);

  return (
    <>
      {state.loading ? (
        <Loading count={1} col={12} height={300} />
      ) : (
        <Fragment>
          {checkEmpty(state.data) ? (
            <CommonFrom
              form={[
                {
                  label: "نام سایت ",
                  size: "col-md-12",
                  classNames: "mt-2",
                  placeholder: "نام مورد نظر را وارد کنید",
                  name: "Sitename",
                  value: `${ShowData(state.data, "Sitename")}`,
                  type: "text",
                },
                {
                  label: "لوگوی سایت",
                  size: "col-md-12",
                  classNames: "mt-2",
                  placeholder: "",
                  name: "Logo",
                  input: "file",
                  accept: "image/png, image/jpeg",
                },
                {
                  label: " دامنه سایت ",
                  size: "col-md-12",
                  classNames: "mt-2",
                  placeholder: "دامنه مورد نظر را وارد کنید",
                  name: "Sitedomin",
                  value: `${ShowData(state.data, "Sitedomin")}`,
                  type: "text",
                },
                {
                  label: " توضیحات ",
                  size: "col-md-12 ",
                  classNames: "mt-2",
                  placeholder: "توضیحات خود را وارد کنید",
                  name: "Description",
                  value: "",
                  type: "text",
                  input: "textarea",
                },
                {
                  label: "اپراتور درگاه پرداخت ",
                  size: "col-md-6",
                  classNames: "mt-2",
                  placeholder: "مقدار مورد نظر را وارد کنید",
                  name: "Getawayoperator",
                  value: `${ShowData(state.data, "Getawayoperator")}`,
                  type: "text",
                },
                {
                  label: "اپراتور  SMS ",
                  size: "col-md-6",
                  classNames: "mt-2",
                  placeholder: "مقدار مورد نظر را وارد کنید",
                  name: "Smsoperator",
                  value: `${ShowData(state.data, "Smsoperator")}`,
                  type: "text",
                },
              ]}
              loading={state.loading}
              submit={submit}
              header="ویرایش اطلاعات سایت"
              btnName="ثبت تغییرات "
            />
          ) : (
            <span>اطلاعات موجود نیست</span>
          )}
        </Fragment>
      )}
    </>
  );
}

export default Index;
